import { z } from 'zod';

export const userMessagesSchema = z.array(
  z.object({
    title: z.string(),
    md: z.string(),
    pinned: z.boolean(),
    created_at: z.string(),
    opts: z
      .object({
        minWidth: z.string().optional(),
        open: z.boolean().optional(),
      })
      .optional(),
  }),
);

type UserMessagesSchemaType = z.infer<typeof userMessagesSchema>;

const defaultValue: UserMessagesSchemaType = [
  {
    title: 'Título de exemplo',
    md: 'Escreva seu texto',
    pinned: true,
    created_at: '2023-01-01',
    opts: {
      minWidth: '100px',
      open: true,
    },
  },
];

export const userMessagesDefaultValue = JSON.stringify(defaultValue, null, '\t');
